export default [
  'Movie',
  'TV series',
  'Documentary',
  'Short film',
  'Animation movie',
];
